const userApi = {
  // getAuth: {
  //   title: '获取用户授权',
  //   url: '/h5/h5Info'
  // },
  // getCode: {
  //   title: '发送验证码',
  //   method: 'post',
  //   url: '/portal/sendCode'
  // },
  // logout: {
  //   title: '解绑手机号',
  //   method: 'post',
  //   url: '/h5/unbind'
  // },
  uploadFile: {
    title: 'uploadFile',
    method: 'post',
    url: '/h5/upload',
    timeout: 300000,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  },
  login: {
    title: 'login',
    method: 'post',
    url: '/h5/login'
  },
  register: {
    title: 'register',
    method: 'post',
    url: '/h5/register'
  },
  update: {
    title: 'update',
    method: 'post',
    url: '/h5/update'
  },
  bankList: {
    title: 'bankList',
    method: 'get',
    url: '/h5/bankList'
  },
  getConfigDetail: {
    title: 'getConfigDetail',
    method: 'get',
    url: '/h5/getConfig'
  },
  getInfo: {
    title: 'getInfo',
    method: 'get',
    url: '/h5/getInfo'
  },
  updatePassword: {
    title: 'updatePassword',
    method: 'post',
    url: '/h5/updatePassword'
  }
}

export default userApi
